import React, { useState } from "react";
import "./warning.scss";

export default function Warning({ title, wrongField }) {

  return (
    <div className="c-warning">
      <h3>{title}</h3>
      <p>{wrongField}</p>
    </div>
  );
}
